import {Injectable} from "@angular/core";
import {AccountTrader} from "../../../model/customer/account-trader";
import {Owner} from "../../../model/customer/owner";
import {ClearingHouse} from "../../../model/exchange/clearing-house";
import {ExchangeDetail} from "../../../model/exchange/exchange-detail";
import {ExecTrader} from "../../../model/customer/exec-trader";
import {MoneyOwner} from "../../../model/customer/money-owner";
import {AccountDefinition} from "../../../model/customer/account-definition";
import {StringUtils} from "../../../utils/stringUtils";
import {Trade} from "../../../model/clearing/trade";
import {AppConfigService} from "../../app-config.service";
import {ClearingFlexService} from "./clearing-flex.service";
import {FieldRecord} from "../../../model/api/field-record";
import {Trader} from "../../../model/customer/trader";
import {BrokerageTable} from "../../../model/customer/brokerage-table";
import {CommonFieldService} from "../../common/common-field.service";
import {FieldsService} from "../../common/fields-service";
import {FieldRequest} from "../../../model/api/field-request";
import {Customer} from "../../../model/customer/customer";
import {ProgressTracker} from "../../../model/api/progress-tracker";

@Injectable({
  providedIn: 'root'
})
export class ClearingFlexTradeDataLoadingService {

  traders: FieldRecord<Trader>[] = [];
  accountTraders: FieldRecord<AccountTrader>[] = [];
  brokerageTables: FieldRecord<BrokerageTable>[] = [];
  owners: FieldRecord<Owner>[] = [];
  clearingHouse: FieldRecord<ClearingHouse>[] = []
  exchanges: FieldRecord<ExchangeDetail>[] = []
  customers: FieldRecord<Customer>[] = [];
  execTraders: FieldRecord<ExecTrader>[] = [];
  moneyOwners: FieldRecord<MoneyOwner>[] = [];
  displayedCustomers: FieldRecord<Customer>[] = [];

  originAccounts: FieldRecord<AccountDefinition>[] = [];
  accounts: FieldRecord<AccountDefinition>[] = [];

  accountTypes: FieldRecord<any>[] = [];
  displayedAccountTypes: FieldRecord<any>[] = [] ;
  displayedGUpAccountTypes: FieldRecord<any>[] = [] ;

  callPuts: FieldRecord<any>[] = [];
  openCloses: FieldRecord<any>[] = [];
  sideOptions: FieldRecord<any>[] = [];
  tradeTypes: FieldRecord<any>[] = [];

  tradeFlexTemplates: FieldRecord<any>[] = [];

  constructor(
    private configService: AppConfigService,
    private commonFieldService: CommonFieldService,
    private fieldsService: FieldsService,
    private clearingFlexService: ClearingFlexService) {
  }

  loadData(tracker: ProgressTracker) {
    // init data
    this.openCloses = Object.keys(AccountDefinition.OpenClose).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.callPuts = Object.keys(Trade.CallPut).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.sideOptions = Object.keys(Trade.Side).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.tradeTypes = ['REG', 'BLK', 'EFP', 'EFS', 'TAS', 'TASB', 'AMK', 'MMK', 'ECR']
      .map(key => new FieldRecord(key, StringUtils.humanize(key)));

    this.fieldsService.loadField(this.owners, () => this.commonFieldService.getOwners(FieldRequest.DEFAULT()), tracker);
    this.fieldsService.loadField(this.clearingHouse, () => this.commonFieldService.getClearingHouses(FieldRequest.DEFAULT()), tracker);
    this.fieldsService.loadField(this.exchanges, () => this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()), tracker, (records) => {
      this.exchanges = this.exchanges.filter(field => {
        return field.text.endsWith(this.configService.flexGwSuffix);
      });
      this.exchanges.forEach(field => {
        field.text = field.text.replace(this.configService.flexGwSuffix, '');
        field.id = field.id.replace(this.configService.flexGwSuffix, '');
      });
    });
    this.fieldsService.loadField(this.customers, () => this.commonFieldService.getCustomers(FieldRequest.DEFAULT()), tracker);
    this.fieldsService.loadField(this.originAccounts, () => this.commonFieldService.getAccounts(FieldRequest.DEFAULT()), tracker);
    this.fieldsService.loadField(this.accountTypes, () => this.commonFieldService.getAccountTypes(FieldRequest.DEFAULT()), tracker);
    this.fieldsService.loadField(this.traders, () => this.commonFieldService.getTraders(FieldRequest.DEFAULT()), tracker);
    this.fieldsService.loadField(this.brokerageTables, () => this.commonFieldService.getBrokerageTables(FieldRequest.DEFAULT()), tracker);

    this.fieldsService.loadField(this.tradeFlexTemplates, () => this.clearingFlexService.getTradeTemplates(), tracker, (records) => {
      records.forEach(field => {
        field.text = StringUtils.humanize(field.text);
      });
    });

  }
}
